export default "__VITE_ASSET__D$qhdBi$__"